"use client";

import { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import Link from "next/link";
import clsx from "clsx";
import S from "./index.module.scss";

type variant = "black" | "white";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: variant;
}

export const Button = ({ variant = "black", className, ...props }: ButtonProps) => {
  return <button className={clsx(S[variant], className)} {...props} />;
};

interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: variant;
  href: string;
}

export const ButtonLink = ({ variant = "black", className, href, ...props }: ButtonLinkProps) => {
  return <Link href={href} className={clsx(S[variant], className)} {...props} />;
};
